import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: "#7C0612",
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: red.A400,
    },
    text: {},
  },
  typography: {
    h1: {
      fontFamily: "Poppins",
    },
    h2: {
      fontFamily: "Poppins",
    },
    h3: {
      fontSize: "1rem",
      fontFamily: "Poppins",
      fontWeight: 500,
      lineSpacing: 20,
    },
    h4: {
      fontFamily: "Poppins",
    },
    h5: {
      fontSize: "1.3rem",
      fontFamily: "Poppins",
      fontWeight: 700,
      lineSpacing: 31,
    },
    h6: {
      fontSize: "1rem",
      fontFamily: "Poppins",
      fontWeight: 500,
      lineSpacing: 20,
    },
    body1: {
      fontFamily: "Roboto",
      fontWeight: 400,
      fontSize: "1.25em",
    },
    caption: {
      color: "#1f1f1f",
      fontWeight: 500,
      fontSize: "1em",
      lineHeight: 1,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        color: "white",
      },
    },
  },
});

export default theme;
